// client/src/components/ForgotPasswordPage.jsx
import { useState } from 'react';
import { LOGO_HORIZONTAL_BLACK, LOGO_HORIZONTAL_WHITE } from '../logo';

export default function ForgotPasswordPage({ onBack }) {
  const [email, setEmail]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async () => {
    setError(''); setLoading(true);
    try {
      await fetch('/api/email/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() })
      });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: '100%', padding: '10px 14px', background: '#0f172a', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, color: '#e2e8f0', fontSize: 14, boxSizing: 'border-box', outline: 'none' };

  const isDark = document.documentElement.getAttribute('data-theme') === 'dark';

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ width: 400, background: '#1e293b', borderRadius: 16, padding: 40, boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src={isDark ? LOGO_HORIZONTAL_WHITE : LOGO_HORIZONTAL_BLACK} alt="Ingenious" style={{ height: 36 }}
            onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='block'; }} />
          <div style={{ display: 'none', color: '#fff', fontSize: 22, fontWeight: 700, letterSpacing: 2 }}>INGENIOUS</div>
          <p style={{ color: '#64748b', marginTop: 8, fontSize: 14 }}>Tendering Dashboard</p>
        </div>

        {submitted ? (
          <div>
            <div style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: 10, padding: '16px 20px', marginBottom: 24, textAlign: 'center' }}>
              <p style={{ color: '#10b981', fontWeight: 600, margin: '0 0 6px' }}>Check your email</p>
              <p style={{ color: '#94a3b8', fontSize: 13, margin: 0 }}>If an account exists for <strong>{email}</strong>, a reset link has been sent. It expires in 1 hour.</p>
            </div>
            <button onClick={onBack}
              style={{ width: '100%', padding: '11px', background: 'transparent', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, color: '#94a3b8', fontSize: 14, cursor: 'pointer' }}>
              Back to Sign In
            </button>
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#f1f5f9', fontSize: 18, fontWeight: 600, margin: '0 0 8px' }}>Reset your password</h2>
            <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 24px' }}>Enter your email address and we'll send you a reset link.</p>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 }}>Email address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                placeholder="you@ingeniouspe.com" style={inputStyle} autoFocus />
            </div>

            {error && (
              <div style={{ background: '#7f1d1d', color: '#fca5a5', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                {error}
              </div>
            )}

            <button onClick={handleSubmit} disabled={loading || !email.trim()}
              style={{ width: '100%', padding: '12px', background: loading || !email.trim() ? '#334155' : '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading || !email.trim() ? 'default' : 'pointer', marginBottom: 12 }}>
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>

            <button onClick={onBack}
              style={{ width: '100%', padding: '11px', background: 'transparent', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, color: '#94a3b8', fontSize: 14, cursor: 'pointer' }}>
              Back to Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
